import React, { useEffect } from 'react';
import { get } from 'lodash';
import { Input } from 'components';
import { useSelect, useAction } from 'hooks';

const TransactionHistorySelect = (props) => {

  const getList = useAction('payment.getList')
  const listing = useSelect('loading.isLoading', { type: 'payment.getList' })
  const list = useSelect('payment.list')

  useEffect(() => {
    getList({ application_status: 'RELEASED' })
    // eslint-disable-next-line
  }, [])

  const options = Object.values(list).map(item => {
    return {
      label: `${get(item,'attributes.module_type')}${get(item, 'id').toString().padStart(6,'0')}`,
      value: get(item, 'id')
    }
  })

  return (
    <Input 
      isLoading={listing}
      label="Case Number"
      type="select"
      options={options}
      {...props}
    />
  )
}

export default TransactionHistorySelect